module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-timeline', [_vm._l((_vm.allMessages), function(message) {
    return [_c('v-timeline-item', {
      key: message.id,
      attrs: {
        "small": "",
        "right": message.sender_type === "practitioner",
        "left": message.sender_type === "client"
      }
    }, [_c('span', {
      attrs: {
        "slot": "opposite"
      },
      slot: "opposite"
    }, [_vm._v("\n        " + _vm._s(message.sender_email)), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.dateformat(message.created, 'ddd, MMM Do YYYY, h:mm a')))])]), _vm._v(" "), _c('v-alert', {
      staticClass: "ma-2 rounded-lg",
      attrs: {
        "value": true,
        "dense": "",
        "outline": ""
      }
    }, [_vm._v("\n        " + _vm._s(message.body)), _c('br'), _vm._v(" "), (message.exercise_name) ? _c('v-chip', {
      staticClass: "v-chip--x-small ml-0",
      attrs: {
        "outline": "",
        "outlined": ""
      }
    }, [_vm._v(_vm._s(message.exercise_name))]) : _vm._e(), _vm._v(" "), (message.exercise_name) ? _c('v-chip', {
      staticClass: "v-chip--x-small ml-0",
      attrs: {
        "outline": "",
        "outlined": "",
        "color": "error"
      }
    }, [_vm._v("\n          Pain: " + _vm._s(message.pain_level))]) : _vm._e(), _vm._v(" "), (message.persisted === false) ? _c('v-progress-circular', {
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "size": "12",
        "indeterminate": "",
        "width": "1",
        "color": "amber"
      }
    }) : _vm._e()], 1)], 1)]
  })], 2), _vm._v(" "), _c('v-textarea', {
    staticClass: "mx-2",
    attrs: {
      "outline": "",
      "outlined": "",
      "auto-grow": "",
      "persistent-hint": "",
      "rows": 1,
      "error-messages": _vm.sendErrors,
      "label": "Send message",
      "append-icon": "send",
      "prepend-icon": "replay",
      "hint": "Press enter to send (shift-enter for a new line)"
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.send.apply(null, arguments)
      },
      "click:append": _vm.send,
      "click:prepend": _vm.t
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d412261","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/Physitrack/Messages.vue
// module id = 1481
// module chunks = 9